<template>
  <div class="mt-auto w-full pb-2">
    <div class="flex w-full justify-between ">
      <div class="flex space-x-2">
        <button
          class="ml-0 px-4 py-2 rounded-md bg-gpx_terracotta-700 text-white hover:bg-gpx_terracotta-300 transition-colors font-medium"
          @click="$emit('update:modelValue', 'newDialog')"
        >
          New Chat
        </button>
        <button
          v-for="tab in leftTabs"
          :key="tab.value"
          class="px-4 py-2 rounded-md border border-gpx_gray-800 bg-white text-gpx_gray-200 hover:bg-gpx_gray-900 transition-colors font-medium"
          :class="modelValue === tab.value ? 'bg-gpx_gray-900 border-gpx_gray-700' : ''"
          @click="$emit('update:modelValue', tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>
<!--      <button
        class="px-4 py-2 rounded-md bg-gpx_terracotta-700 text-white hover:bg-gpx_terracotta-300 transition-colors font-medium"
        @click="$emit('update:modelValue', 'newDialog')"
      >
        New Chat
      </button>-->
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

defineProps({
  modelValue: {
    type: String,
    required: true
  },
});

const leftTabs = computed(() => [
  //{ value: 'home', label: 'Home' },
  { value: 'history', label: 'History' }
]);

defineEmits(['update:modelValue']);
</script>
